document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.custom-bundle-builder');
  if (!container) return;

  const CONFIG = {
    productId: container.dataset.productId,
    sectionId: document.querySelector('.custom-bundle-section').dataset.sectionId
  };

  // State
  let state = {
    packSize: 3, // Default
    selectedSize: null, // e.g., 'M'
    slots: [], // Array of { color: 'Black', variantId: 123, image: 'url' }
    variants: [],
    preorderIds: new Set() // variant IDs that are out-of-stock but pre-orderable
  };
  let preorderNoticeShown = false;

  // Elements
  const els = {
    jsonScript: document.getElementById(`BundleProductJson-${CONFIG.sectionId}`),
    sizeBtns: container.querySelectorAll('.bundle-size-btn'),
    productSizeInputs: container.querySelectorAll('input[name="bundle-size"]'),
    slotsContainer: document.getElementById('bundle-slots'),
    colorSwatches: container.querySelectorAll('.color-swatch-item'),
    totalPriceDisplay: document.getElementById('bundle-total-price'),
    comparePriceDisplay: document.getElementById('bundle-compare-price'),
    addToCartBtn: document.getElementById('add-bundle-to-cart'),
    errorMessage: document.getElementById('bundle-error-message'),
    modal: document.getElementById('custom-bundle-modal'),
    openModalBtns: document.querySelectorAll('.open-bundle-builder-trigger, #open-bundle-builder'), // Support both class and ID
    closeModalBtn: document.getElementById('close-bundle-modal'),
    modalOverlay: document.querySelector('.custom-bundle-modal-overlay')
  };

  // Init
  function init() {
    console.log('[Custom Bundle] Init started');

    // Bind separate modal events first, so popup always works
    bindModalEvents();

    if (!container) {
      console.warn('[Custom Bundle] Container .custom-bundle-builder not found. Modal will be empty or show default message.');
      return;
    }

    if (els.jsonScript) {
      console.log('[Custom Bundle] JSON data found');
      const productData = JSON.parse(els.jsonScript.textContent);
      if (productData) {
        state.variants = productData.variants || [];
        state.preorderIds = new Set(productData.preorderVariantIds || []);
        state.preorderPopup = (productData.preorderPopup || '').trim();
        state.bundleSizes = (productData.bundleSizes || []).map(s => parseInt(s.trim()));
        state.bundleDiscounts = (productData.bundleDiscounts || []).map(d => {
          const val = d.trim();
          if (val.startsWith('$')) {
            const numericPart = val.replace('$', '').trim();
            return { type: 'fixed', value: parseFloat(numericPart) * 100 };
          }
          return { type: 'percentage', value: parseFloat(val) / 100 };
        });
        console.log('[Custom Bundle] Loaded variants:', state.variants.length);
        console.log('[Custom Bundle] Loaded discounts:', state.bundleDiscounts);
      }
    }

    // Set initial pack size logic
    const activeSizeBtn = container.querySelector('.bundle-size-btn.active');
    if (activeSizeBtn) {
      updatePackSize(parseInt(activeSizeBtn.dataset.size));
    } else if (els.sizeBtns.length > 0) {
      updatePackSize(parseInt(els.sizeBtns[0].dataset.size));
    }

    // Set initial product size logic
    const checkedSizeInput = container.querySelector('input[name="bundle-size"]:checked');
    if (checkedSizeInput) {
      state.selectedSize = checkedSizeInput.value;
    }

    // Update Trigger Buttons Text if specified
    const triggerText = container.closest('.custom-bundle-section').dataset.triggerText;
    if (triggerText && els.openModalBtns.length > 0) {
      els.openModalBtns.forEach(btn => {
        btn.textContent = triggerText;
      });
      console.log('[Custom Bundle] Updated trigger buttons text:', triggerText);
    }

    bindBuilderEvents();
    renderSlots();
    updateVariantAvailability();
    // If default selected size is out of stock, select first available size
    const checkedInput = container.querySelector('input[name="bundle-size"]:checked');
    if (checkedInput && checkedInput.disabled) {
      const firstAvailable = container.querySelector('input[name="bundle-size"]:not(:disabled)');
      if (firstAvailable) {
        firstAvailable.checked = true;
        state.selectedSize = firstAvailable.value;
        updateVariantAvailability();
      }
    }
    updateUI();
  }

  function bindModalEvents() {
    if (els.openModalBtns && els.openModalBtns.length > 0) {
      els.openModalBtns.forEach(btn => {
        btn.addEventListener('click', openModal);
      });
      console.log(`[Custom Bundle] Bound click to ${els.openModalBtns.length} trigger buttons`);
    } else {
      console.warn('[Custom Bundle] No trigger buttons found (checked .open-bundle-builder-trigger and #open-bundle-builder).');
    }

    if (els.closeModalBtn) els.closeModalBtn.addEventListener('click', closeModal);
    if (els.modalOverlay) els.modalOverlay.addEventListener('click', closeModal);
  }

  function bindBuilderEvents() {
    // Pack Size Click
    els.sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        els.sizeBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updatePackSize(parseInt(btn.dataset.size));
      });
    });

    // Product Size Change
    els.productSizeInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        if (input.disabled) return;
        state.selectedSize = e.target.value;
        updateVariantAvailability(); // Update color swatches for new size
        updateUI();
      });
    });

    // Color Swatch Click (skip if out-of-stock)
    els.colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        if (swatch.classList.contains('out-of-stock')) return;
        const color = swatch.dataset.color;
        const image = swatch.dataset.image;
        addColorToSlot(color, image);
      });
    });

    // Slot Click (Remove)
    els.slotsContainer.addEventListener('click', (e) => {
      const slot = e.target.closest('.bundle-slot.filled');
      if (slot) {
        const index = parseInt(slot.dataset.index);
        removeSlot(index);
      }
    });

    // Add to Cart
    els.addToCartBtn.addEventListener('click', addToCart);
  }

  // Read the size the customer selected on the product page (Step 2 of the
  // native variant picker). Handles both button-style (radio) and dropdown
  // (select) size pickers, and ignores the bundle popup's own size radios.
  function getProductPageSelectedSize() {
    const scopes = document.querySelectorAll('fieldset[data-handle="size"]');
    for (const fs of scopes) {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) return checked.value;
      const select = fs.querySelector('select');
      if (select && select.value) return select.value;
    }
    return null;
  }

  // Carry the product-page size selection into the popup's Step 2 so the size
  // the customer already picked stays selected when the builder opens.
  function syncSizeFromProductPage() {
    const size = getProductPageSelectedSize();
    if (!size) return;
    const input = Array.from(els.productSizeInputs).find(i => i.value === size);
    if (!input || input.disabled || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function openModal() {
    els.modal.classList.add('open');
    document
      .querySelector(".custom-bundle-section")
      .classList.add("active");
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
    syncSizeFromProductPage();
  }

  function closeModal() {
    document
      .querySelector(".custom-bundle-section")
      .classList.remove("active");
    els.modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updatePackSize(size) {
    state.packSize = size;
    // Resize slots array. Use 0-filled or truncate
    const newSlots = new Array(size).fill(null);
    // Copy existing filled slots over if possible
    state.slots.forEach((s, i) => {
      if (i < size) newSlots[i] = s;
    });
    state.slots = newSlots;
    renderSlots();
    updateUI();
  }

  function addColorToSlot(color, image) {
    // Find first empty slot
    const emptyIndex = state.slots.findIndex(s => s === null);
    if (emptyIndex === -1) {
      // Full, maybe replace the last one or notify user? 
      // Reference behavior: usually overwrite last or do nothing.
      // Let's replace the last one for now, or do nothing? 
      // Better UX: Shake the slots or show message "Pack is full"
      return;
    }

    // Find variant for this Color + Selected Size
    const variant = findVariant(state.selectedSize, color);

    if (!variant) {
      console.warn('Variant not found for', state.selectedSize, color);
      // Maybe visually disable swatches that aren't available?
      return;
    }

    const isPre = isPreorderVariant(variant);
    if (!variant.available && !isPre) return;

    // First time a pre-order color is added, surface the ship-date notice.
    // TEMP HIDDEN 2026-10-16: pre-order popup disabled per client. To restore, uncomment the line below.
    // if (isPre) showPreorderNotice();

    state.slots[emptyIndex] = {
      color: color,
      image: image,
      size: state.selectedSize,
      variantId: variant.id,
      price: variant.price,
      preorder: isPre
    };

    renderSlots();
    updateUI();
  }

  function showPreorderNotice() {
    if (preorderNoticeShown) return;
    preorderNoticeShown = true;
    const cfg = (window.theme && window.theme.preorder) || {};
    // Per-product override (custom.pre_order_popup_text) wins, then global config, then default.
    const message = state.preorderPopup || cfg.popup || 'This will ship after the 1st of September.';
    const backdrop = document.createElement('div');
    backdrop.className = 'bundle-preorder-notice__backdrop';
    backdrop.innerHTML =
      '<div class="bundle-preorder-notice__box" role="dialog" aria-modal="true" aria-label="Pre-order notice">' +
        '<p class="bundle-preorder-notice__title">Pre-order</p>' +
        '<p class="bundle-preorder-notice__text"></p>' +
        '<button type="button" class="bundle-preorder-notice__btn">Got it</button>' +
      '</div>';
    backdrop.querySelector('.bundle-preorder-notice__text').textContent = message;
    const close = () => {
      backdrop.classList.remove('is-open');
      setTimeout(() => backdrop.remove(), 200);
    };
    backdrop.addEventListener('click', (ev) => { if (ev.target === backdrop) close(); });
    backdrop.querySelector('.bundle-preorder-notice__btn').addEventListener('click', close);
    document.body.appendChild(backdrop);
    requestAnimationFrame(() => backdrop.classList.add('is-open'));
  }

  function removeSlot(index) {
    state.slots[index] = null;
    renderSlots();
    updateUI();
  }

  function updateSlotVariantIds() {
    // Re-check all filled slots against the new size
    state.slots = state.slots.map(slot => {
      if (!slot) return null;
      const variant = findVariant(state.selectedSize, slot.color);
      if (variant && (variant.available || isPreorderVariant(variant))) {
        return { ...slot, variantId: variant.id, price: variant.price, preorder: isPreorderVariant(variant) };
      } else {
        // Option A: Keep it but mark invalid?
        // Option B: Remove it?
        // Let's remove it if invalid size combo
        return null;
      }
    });
    renderSlots();
  }

  function findVariant(size, color) {
    return state.variants.find(v => {
      // Logic assumes options are Size and Color. 
      // Option order can vary.
      return (v.option1 === size || v.option2 === size || v.option3 === size) &&
        (v.option1 === color || v.option2 === color || v.option3 === color);
    });
  }

  /** True when the given variant is out of stock but purchasable as a pre-order. */
  function isPreorderVariant(variant) {
    return !!(variant && state.preorderIds.has(variant.id));
  }

  /** Check if any variant with this size can be bought (in stock OR pre-order). */
  function isSizeAvailable(size) {
    return state.variants.some(v => {
      const hasSize = v.option1 === size || v.option2 === size || v.option3 === size;
      return hasSize && (v.available || isPreorderVariant(v));
    });
  }

  /** Update which size options and color swatches are disabled based on inventory. */
  function updateVariantAvailability() {
    if (!state.variants || state.variants.length === 0) return;

    // Step 2: Size options – disable sizes with no available variant (any color)
    els.productSizeInputs.forEach(input => {
      const sizeValue = input.value;
      const label = input.closest('.size-option');
      const available = isSizeAvailable(sizeValue);
      if (label) {
        label.classList.toggle('out-of-stock', !available);
      }
      input.disabled = !available;
    });

    // Step 3: Color swatches – pre-order colors stay selectable (red label);
    // truly sold-out colors are disabled.
    const selectedSize = state.selectedSize;
    els.colorSwatches.forEach(swatch => {
      const color = swatch.dataset.color;
      const variant = findVariant(selectedSize, color);
      const isPre = isPreorderVariant(variant);
      const available = !!(variant && variant.available);
      swatch.classList.toggle('pre-order', isPre);
      swatch.classList.toggle('out-of-stock', !available && !isPre);
      swatch.setAttribute('aria-disabled', (available || isPre) ? 'false' : 'true');
    });
  }

  function renderSlots() {
    els.slotsContainer.innerHTML = '';
    state.slots.forEach((slot, index) => {
      const div = document.createElement('div');
      div.className = `bundle-slot ${slot ? 'filled' : 'empty'}`;
      div.dataset.index = index;

      if (slot) {
        div.innerHTML = `
          <img src="${slot.image}" alt="${slot.color}">
          <span class="remove-slot">×</span>
          <div class="slot-label">${slot.color}<br>${slot.size}</div>
        `;
      } else {
        div.innerHTML = `<span class="slot-placeholder">${index + 1}</span>`;
      }
      els.slotsContainer.appendChild(div);
    });
  }

  function updateUI() {
    // Update Price
    const filledSlots = state.slots.filter(s => s !== null);
    const total = filledSlots.reduce((acc, curr) => acc + curr.price, 0);

    // Discount Logic
    let discountedTotal = total;
    let hasDiscount = false;

    if (state.bundleSizes && state.bundleDiscounts) {
      const sizeIndex = state.bundleSizes.indexOf(state.packSize);
      if (sizeIndex !== -1) {
        const discountObj = state.bundleDiscounts[sizeIndex];
        if (discountObj) {
          if (discountObj.type === 'percentage' && discountObj.value > 0) {
            discountedTotal = total * (1 - discountObj.value);
            hasDiscount = true;
          } else if (discountObj.type === 'fixed' && discountObj.value > 0) {
            // Apply discount proportionally based on current filling
            const proportion = filledSlots.length / state.packSize;
            discountedTotal = total - (discountObj.value * proportion);
            hasDiscount = true;
          }
        }
      }
    }

    if (hasDiscount && filledSlots.length > 0) {
      els.comparePriceDisplay.textContent = formatMoney(total);
      els.comparePriceDisplay.style.display = 'inline';
      els.totalPriceDisplay.textContent = formatMoney(discountedTotal);
    } else {
      els.comparePriceDisplay.textContent = '';
      els.comparePriceDisplay.style.display = 'none';
      els.totalPriceDisplay.textContent = formatMoney(total);
    }

    // Enable/Disable Add to Cart
    const isFull = filledSlots.length === state.packSize;
    els.addToCartBtn.disabled = !isFull;

    // Highlight incomplete
    if (!isFull) {
      els.errorMessage.textContent = `Select ${state.packSize - filledSlots.length} more pieces`;
    } else {
      els.errorMessage.textContent = '';
    }
  }

  function addToCart() {
    const filledSlots = state.slots.filter(s => s !== null);
    if (filledSlots.length !== state.packSize) return;

    els.addToCartBtn.classList.add('loading');
    els.addToCartBtn.textContent = 'Adding...';

    const items = filledSlots.map(slot => ({
      id: slot.variantId,
      quantity: 1
    }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(response => {
        if (response.ok) {
          // Success Feedback
          els.addToCartBtn.textContent = 'Added to Cart!';
          els.addToCartBtn.classList.remove('loading');

          // Optional: Trigger theme cart update events if they exist
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

          // Reset after a delay
          setTimeout(() => {
            els.addToCartBtn.textContent = 'Add To Cart';
            // Optionally clear slots or close modal here? User didn't ask, so keep state.
            closeModal();
          }, 2000);

        } else {
          return response.json().then(data => { throw new Error(data.description); });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        els.errorMessage.textContent = error.message;
        els.addToCartBtn.classList.remove('loading');
        els.addToCartBtn.textContent = 'Add To Cart';
      })
      .finally(() => {
        // Maybe open minicart?
      });
  }

  function formatMoney(cents) {
    var hasFraction = cents % 100 !== 0;
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD', // hardcoded for now, ideal to use Shopify currency
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  init();
});
